<template>
  <div class="intent_wrapper">
    <div class="title">교재 관리</div>

    <b-container class="formlayout">
      <b-form>
        <b-row>
          <b-col offset-lg="6" offset-sm="4" off sm="4" lg="4">
            <b-form-group
              label="세듀북 가져오기"
              label-for="input-cedubook"
              label-size="default"
              label-cols-sm="4"
              label-cols-lg="4"
            >
              <b-form-input
                id="input-cedubook"
                v-model="cedubook"
                placeholder="교재아이디(prdcode)"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button variant="primary" @click="getcedubook">가져오기</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" lg="6">
            <b-form-group
              label="ISBN"
              label-for="input-isbn"
              label-size="default"
            >
              <b-form-input
                id="input-isbn"
                v-model="isbn"
                placeholder="책에서 제공하는 isbn"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="저작자"
              label-for="input-owner"
              label-size="default"
            >
              <b-form-input
                id="input-owner"
                v-model="owner"
                placeholder="저작자"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12">
            <b-form-group
              label="교재명"
              label-for="input-title"
              label-size="default"
            >
              <b-form-input
                id="input-title"
                v-model="title"
                placeholder="교재명"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" lg="6">
            <b-form-group
              label="학습영역"
              label-for="input-region"
              label-size="default"
            >
              <b-form-input
                id="input-region"
                v-model="region"
                placeholder="학습영역(필수)"
              ></b-form-input>
              <b-select
                v-model="region"
                text-field="cdnm"
                value-field="cd"
                :options="area"
              ></b-select>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="6">
            <b-form-group
              label="학습대상"
              label-for="input-target"
              label-size="default"
            >
              <b-form-input
                id="input-target"
                v-model="target"
                placeholder="학습대상(필수)"
              ></b-form-input>

              <b-form-group label="학습대상*">
                <b-form-checkbox-group
                  v-model="target"
                  :options="targetX"
                  name="buttons-1"
                  value-field="cd"
                  text-field="cdnm"
                  button-variant="info"
                  buttons
                ></b-form-checkbox-group>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" lg="6">
            <b-form-group
              label="출간일"
              label-for="input-pubdate"
              label-size="default"
            >
              <b-form-input
                id="input-pubdate"
                v-model="pubdate"
                placeholder="출간일(선택)"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="6">
            <b-form-group
              label="등록문항수"
              label-for="input-target"
              label-size="default"
            >
              <b-form-input
                id="input-target"
                v-model="qcount"
                readonly
                placeholder="자동계산"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" lg="6">
            <b-form-group
              label="컨텐츠 팩토리 검색노출여부"
              label-size="default"
            >
              <b-select
                v-model="meta1"
                text-field="cdnm"
                value-field="cd"
                :options="enabled"
              ></b-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="AI-클리닉 노출여부" label-size="default">
              <b-select
                v-model="meta2"
                text-field="cdnm"
                value-field="cd"
                :options="enabled"
              ></b-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" lg="6">
            <b-form-group label="어휘용교재여부" label-size="default">
              <b-select
                v-model="meta3"
                text-field="cdnm"
                value-field="cd"
                :options="enabled"
              ></b-select>
            </b-form-group>

            </b-col>
        </b-row>


        <b-row>
          <b-col sm="12" lg="12">
            <b-form-group
              label="표지이미지"
              label-for="input-coverimg"
              label-size="default"
            >
              <b-form-input
                id="input-coverimg"
                v-model="coverimg"
                placeholder="표지이미지(자동업로드)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <div class="buttonbox">
        <b-button variant="success" @click="doPost()">{{
          processText
        }}</b-button>
        <b-button variant="danger" @click="back_list()">취소</b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
import * as R from "ramda";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  mounted() {
    this.$store.state.subtitle = "교재등록";
    let _id = this.$route.query.id;
    // alert(this.$route.query.id);
    if (_id != null) {
      this.$store.dispatch("loadBookbyId", _id);
    }
    this.getAreaCode();
    this.getTargetCode();
  },
  data() {
    return {
      cedubook: "",
      qcount: 0,
      target1: [],
    };
  },
  computed: {
    ...mapState("chapterStore", ["area", "targets", "enabled"]),
    targetX() {
      let k = R.map((f) => {
        f.checked = false;
        return f;
      }, this.targets);

      console.log(k);
      return k;
    },
    processText() {
      if (this.$store.state.bookform.id != "") {
        return "수정";
      } else {
        return "등록";
      }
    },
    isbn: {
      get() {
        return this.$store.state.bookform.isbn;
      },
      set(value) {
        this.$store.commit("updateIsbn", value);
      },
    },

    owner: {
      get() {
        return this.$store.state.bookform.owner;
      },
      set(value) {
        this.$store.commit("updateOwner", value);
      },
    },
    title: {
      get() {
        return this.$store.state.bookform.title;
      },
      set(value) {
        this.$store.commit("updateTitle", value);
      },
    },
    region: {
      get() {
        return this.$store.state.bookform.region;
      },
      set(value) {
        this.$store.commit("updateRegion", value);
      },
    },
    target: {
      get() {
        return this.$store.state.bookform.target;
      },
      set(value) {
        this.$store.commit("updateTarget", value);
      },
    },
    pubdate: {
      get() {
        return this.$store.state.bookform.pubdate;
      },
      set(value) {
        this.$store.commit("updatePubdate", value);
      },
    },
    coverimg: {
      get() {
        return this.$store.state.bookform.coverimg;
      },
      set(value) {
        this.$store.commit("updateCoverimg", value);
      },
    },

    meta1: {
      get() {
        return this.$store.state.bookform.meta1;
      },
      set(value) {
        this.$store.commit("updateMeta1", value);
      },
    },
    meta2: {
      get() {
        return this.$store.state.bookform.meta2;
      },
      set(value) {
        this.$store.commit("updateMeta2", value);
      },
    },
    
    meta3: {
      get() {
        return this.$store.state.bookform.meta3;
      },
      set(value) {
        this.$store.commit("updateMeta3", value);
      },
    },

  },
  methods: {
    ...mapActions("chapterStore", ["getAreaCode", "getTargetCode"]),

    getcedubook() {
      this.$store.dispatch("getcedubook", this.cedubook);
    },
    back_list() {
      this.$router.push("/admin/book/list");
    },
    doPost() {
      this.$store.dispatch("postBook");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.formlayout {
  margin-top: 10px;
}
.buttonbox {
  text-align: center;
  button {
    margin-right: 10px;
  }
}

.intent_wrapper {
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 3px 3px $gray400;

  margin: 20px;
  padding: 20px;
  .title {
    font-size: 1.2em;
    color: $gray50;
    background-color: $gray600;
    border-radius: 4px;
    padding-bottom: 6px;
  }
  .title::before {
    content: "";
    font-size: 1.5em;
    padding-left: 6px;
    color: $gray50;
  }
  .searchbox {
    margin: 10px 0 10px 0;
    .divider {
    }
  }
  .buttons {
    text-align: right;
    margin: 4px 0 4px 0;
  }

  .nodata {
    text-align: center;
    color: $point1;
  }
}
</style>